import Image from 'next/image';
import React from 'react';

import FlexBox from '@/components/FlexBox';
import HRbaseLogoImage from '@/images/hrbase_logo.png';
import HRbaseProLogoImage from '@/images/hrbase_pro_logo.png';

const CommonLogo = (): JSX.Element => {
  return (
    <FlexBox variant='center' classes={['relative', 'gap-x-4', 'items-center']}>
      <div>
        <Image src={HRbaseProLogoImage} width={162} height={68} alt='ロゴ' />
      </div>
      <div className='mt-2'>
        <Image src={HRbaseLogoImage} width={162} height={62} alt='ロゴ' />
      </div>
    </FlexBox>
  );
};

export default CommonLogo;
